module.exports = __webpack_public_path__ + "static/media/8_r_paporotnik2_89.95_55.46.02349927.png";